import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BankEntryRow;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import partial from 'lodash/partial';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { IconEditLine, IconPlusLine, IconCopyLine, IconTrashLine } from '@instructure/ui-icons';
import { IconButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { List } from '@instructure/ui-list';
import { Heading } from '@instructure/ui-heading';
import { PresentationContent } from '@instructure/ui-a11y-content';
import { Alert } from '@instructure/ui-alerts';
import { jsx } from '@instructure/emotion';
import { BUILD_TRAY_POSITION, COPY_MOVE_BANK_ENTRY_MODAL, SET_EDIT_BUTTON_FOCUS, withI18nSupport, withStyleOverrides } from '@instructure/quiz-common';
import { RichContentRenderer } from '@instructure/quiz-rce';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import t from '@instructure/quiz-i18n/es/format-message';
import CopyMoveBankEntryModal from '../CopyMoveBankEntryModal';
import ExpandButton from '../../../common/components/shared/ExpandButton';
import QuizEntry from '../../../common/records/QuizEntry';
import ItemShow from '../../../common/components/resources/item/ItemShow';
import StimulusShowInfo from '../../../common/components/resources/stimulus/StimulusShowInfo';
import TagDisplay from '../../../common/components/shared/TagDisplay';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import Overlay from '../../../common/components/shared/overlay';
export var BankEntryRow = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BankEntryRow = /*#__PURE__*/function (_withI18nSupport) {
  function BankEntryRow() {
    var _this;
    _classCallCheck(this, BankEntryRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BankEntryRow, [].concat(args));
    _defineProperty(_this, "incrementPosition", function () {
      _this.props.setUi(BUILD_TRAY_POSITION, _this.props.position + 1);
    });
    _defineProperty(_this, "deleteBankEntry", function () {
      var deletePreface = _this.isItemEntry() ? t('Deleting this question:') : t('Deleting this stimulus:');
      var confirmBody = jsx(Alert, {
        variant: "error",
        padding: "0"
      }, jsx("div", {
        css: _this.props.styles.deleteAlert
      }, jsx("div", {
        css: _this.props.styles.deletePreface
      }, deletePreface), jsx(List, null, jsx(List.Item, null, t.rich('will <0>NOT</0> remove it from any assessments', [function (_ref) {
        var children = _ref.children;
        return jsx(Text, {
          weight: "bold",
          key: "0"
        }, children);
      }])), jsx(List.Item, null, t('will lose its statistical link in reporting')), jsx(List.Item, null, t('will remove access for all users with whom this bank has been shared')))));
      _this.props.withConfirm(partial(_this.props.removeBankEntry, _this.props.bank.id, _this.props.bankEntry.id), {
        title: t('Delete {type}', {
          type: _this.type()
        }),
        text: confirmBody,
        continueText: t('Delete'),
        continueVariant: 'danger',
        size: 'medium'
      });
    });
    _defineProperty(_this, "addToQuiz", function () {
      if (_this.props.activeQuizId) {
        var newEntry = QuizEntry.create({
          entryId: _this.props.bankEntry.id,
          entryType: 'BankEntry',
          position: _this.props.position,
          stimulusQuizEntryId: _this.props.stimulusId
        });
        _this.props.addEntryToQuiz(_this.props.activeQuizId, newEntry.entryId, newEntry.entryType, newEntry.getProperties(), false).then(function () {
          _this.props.screenreaderNotification(t('Bank Entry was successfully added to the quiz'));
        });
        if (_this.props.position) _this.incrementPosition();
      }
    });
    _defineProperty(_this, "openCopyMoveBankEntryModal", function () {
      _this.props.openModal([COPY_MOVE_BANK_ENTRY_MODAL, _this.props.bankEntry.entryType, _this.props.bankEntry.entry.toJS().id].join(':'), {
        modalTrigger: _this.copyMoveBankEntryButton
      });
    });
    _defineProperty(_this, "createEntryForBank", function () {
      var createEntry = _this.isItemEntry() ? _this.props.createItem : _this.props.createStimulus;
      return createEntry(_this.getEntry(), _this.props.bank.id, 'bank');
    });
    _defineProperty(_this, "storeCopyMoveBankEntryButtonRef", function (c) {
      _this.copyMoveBankEntryButton = c;
    });
    _defineProperty(_this, "storeEditButtonRef", function (c) {
      _this.editButton = c;
    });
    _defineProperty(_this, "renderTrashButton", function () {
      var title = t('Delete {type}', {
        type: _this.type()
      });
      return jsx(IconButton, {
        size: "medium",
        withBackground: false,
        withBorder: false,
        onClick: _this.deleteBankEntry,
        "data-automation": "sdk-delete-bank-entry-button",
        renderIcon: IconTrashLine,
        title: title,
        screenReaderLabel: title
      });
    });
    _defineProperty(_this, "navigateToBankEntry", function () {
      _this.props.setUi(SET_EDIT_BUTTON_FOCUS, _this.props.bankEntry.id);
      _this.props.navigateToBankEntry(_this.props.bankEntry.id, _this.props.bank.id);
    });
    return _this;
  }
  _inherits(BankEntryRow, _withI18nSupport);
  return _createClass(BankEntryRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.bankEntry.id === this.props.setEditButtonFocus) {
        this.editButton.focus();
        this.props.clearUi(SET_EDIT_BUTTON_FOCUS);
      }
    }
  }, {
    key: "getEntry",
    value: function getEntry() {
      return this.props.bankEntry.getEntry();
    }
  }, {
    key: "isItemEntry",
    value: function isItemEntry() {
      return this.props.bankEntry.entryType === 'Item';
    }
  }, {
    key: "type",
    value: function type() {
      return this.isItemEntry() ? t('Question') : t('Stimulus');
    }
  }, {
    key: "entryIdentifier",
    value: function entryIdentifier() {
      return this.isItemEntry() ? t('Question { itemBody }', {
        itemBody: extractTextFromHtml(this.getEntry().title)
      }) : t('Stimulus { title }', {
        title: this.getEntry().title
      });
    }
  }, {
    key: "moveModalTitle",
    value: function moveModalTitle() {
      return t('Copy / Move {type}', {
        type: this.type()
      });
    }
  }, {
    key: "renderExpandButton",
    value: function renderExpandButton() {
      var type = this.type();
      var title = this.props.isExpanded ? t('Collapse {type} details', {
        type: type
      }) : t('Expand {type} details', {
        type: type
      });
      return jsx("div", {
        css: this.props.styles.expandButtonContainer
      }, jsx(ExpandButton, {
        onClick: this.props.toggleExpanded,
        title: title,
        isExpanded: this.props.isExpanded,
        "data-automation": "expand-bank-question-button"
      }));
    }
  }, {
    key: "renderAddButton",
    value: function renderAddButton() {
      if (!this.props.isQuizContentLocked && this.props.addEntryToQuiz) {
        var title = t('Add {type} to this quiz', {
          type: this.type()
        });
        return jsx("div", {
          css: [this.props.styles.buttons, this.props.styles.addButton]
        }, jsx(IconButton, {
          color: "primary",
          shape: "circle",
          size: "small",
          onClick: this.addToQuiz,
          "data-automation": "sdk-add-bank-entry-button",
          disabled: this.props.bankEntry.isStimulus && this.props.stimulusId !== null,
          renderIcon: IconPlusLine,
          title: title,
          screenReaderLabel: title
        }));
      }
      // This empty div is necessary for spacing
      return jsx("div", null);
    }
  }, {
    key: "renderMoveButton",
    value: function renderMoveButton() {
      var title = this.moveModalTitle();
      return jsx(IconButton, {
        ref: this.storeCopyMoveBankEntryButtonRef,
        size: "medium",
        withBackground: false,
        withBorder: false,
        onClick: this.openCopyMoveBankEntryModal,
        "data-automation": "sdk-copy-move-bank-entry-button",
        renderIcon: IconCopyLine,
        title: title,
        screenReaderLabel: title
      });
    }
  }, {
    key: "entryHeader",
    value: function entryHeader() {
      return this.isItemEntry() ? this.getEntry().getInteractionType().name : t('Stimulus');
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var separator = ' | ';
      return jsx("div", null, jsx("div", {
        css: this.props.styles.headerRow
      }, this.renderAddButton(), jsx("div", {
        css: this.props.styles.buttons
      }, this.props.bank.canEdit() && jsx(React.Fragment, null, this.renderEditButton(), this.renderMoveButton(), this.renderTrashButton()), this.renderExpandButton())), jsx("div", {
        css: this.props.styles.headerText
      }, jsx(Heading, {
        level: "reset",
        as: "h2"
      }, this.entryHeader(), jsx(PresentationContent, null, separator), this.entryIdentifier())));
    }
  }, {
    key: "renderEntryCollapsed",
    value: function renderEntryCollapsed() {
      var itemOrStimulus = this.getEntry();

      // render item's body as html
      // or title plain text
      if (itemOrStimulus.itemBody) {
        return jsx(RichContentRenderer, {
          customStyles: this.props.styles.stem,
          content: itemOrStimulus.itemBody
        });
      } else {
        return jsx("div", {
          css: this.props.styles.stem
        }, itemOrStimulus.title);
      }
    }
  }, {
    key: "renderEntryExpanded",
    value: function renderEntryExpanded() {
      var entry = this.getEntry();
      if (this.isItemEntry()) {
        return jsx(ItemShow, {
          entry: entry,
          guid: this.props.bankEntry.id
        });
      } else {
        return jsx(StimulusShowInfo, {
          stimulus: entry
        });
      }
    }
  }, {
    key: "renderEditButton",
    value: function renderEditButton() {
      var title = t('Edit {type}', {
        type: this.type()
      });
      return jsx(IconButton, {
        ref: this.storeEditButtonRef,
        size: "medium",
        withBackground: false,
        withBorder: false,
        onClick: this.navigateToBankEntry,
        "data-automation": "sdk-edit-bank-entry-button",
        renderIcon: IconEditLine,
        title: title,
        screenReaderLabel: title
      });
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      if (!this.props.useBankTags) {
        return null;
      }
      return jsx(TagDisplay, {
        tagAssociations: this.props.tagAssociations
      });
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var lastUpdate = t.rich('<0>Last Update</0> { updatedAt }', {
        0: function _(_ref2) {
          var children = _ref2.children;
          return jsx(Text, {
            key: "lastUpdate",
            weight: "bold",
            color: "primary"
          }, children);
        },
        updatedAt: this.formatDatetimeMedium(this.props.bankEntry.get('updatedAt'))
      });
      return jsx("div", {
        css: this.props.styles.footer
      }, jsx("span", null, lastUpdate), this.renderTags());
    }
  }, {
    key: "render",
    value: function render() {
      var isExpanded = this.props.isExpanded;
      return jsx(Overlay, {
        onClick: this.props.toggleExpanded,
        tabIndex: "-1",
        ariaLabel: this.entryIdentifier()
      }, jsx("div", {
        role: "group"
      }, jsx("div", {
        css: this.props.styles.entryDetail,
        "data-automation": "sdk-bankEntryItem"
      }, this.renderHeader(), isExpanded ? this.renderEntryExpanded() : this.renderEntryCollapsed()), isExpanded && this.renderFooter()), jsx(CopyMoveBankEntryModal, {
        createEntry: this.createEntryForBank,
        label: this.moveModalTitle(),
        sourceBankId: this.props.bank.id,
        sourceBankEntryId: this.props.bankEntry.id,
        entryId: this.props.bankEntry.entry.get('id'),
        entryType: this.props.bankEntry.entryType
      }));
    }
  }]);
}(withI18nSupport(Component)), _defineProperty(_BankEntryRow, "displayName", 'BankEntryRow'), _defineProperty(_BankEntryRow, "componentId", "Quizzes".concat(_BankEntryRow.displayName)), _defineProperty(_BankEntryRow, "propTypes", {
  activeQuizId: PropTypes.string,
  addEntryToQuiz: PropTypes.func,
  bankEntry: ImmutablePropTypes.record.isRequired,
  bank: ImmutablePropTypes.record.isRequired,
  clearUi: PropTypes.func.isRequired,
  createItem: PropTypes.func.isRequired,
  createStimulus: PropTypes.func.isRequired,
  isQuizContentLocked: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool,
  navigateToBankEntry: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  position: PropTypes.number,
  removeBankEntry: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  setEditButtonFocus: PropTypes.bool,
  setUi: PropTypes.func.isRequired,
  stimulusId: PropTypes.string,
  tagAssociations: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  useBankTags: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  withConfirm: PropTypes.func.isRequired,
  locale: PropTypes.string,
  timezone: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_BankEntryRow, "defaultProps", {
  activeQuizId: null,
  addEntryToQuiz: null,
  stimulusId: null,
  isQuizContentLocked: false,
  isExpanded: false,
  position: 0,
  setEditButtonFocus: false,
  tagAssociations: Immutable.List(),
  locale: null,
  timezone: null
}), _defineProperty(_BankEntryRow, "contextTypes", {
  locale: PropTypes.string,
  timezone: PropTypes.string
}), _BankEntryRow)) || _class);
export default BankEntryRow;